import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { DependencyGraph } from "~app/common/services/cqs/DependencyGraph";
import { KartgeometriPopupComponent } from "./kartgeometri-popup.component";

@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        KartgeometriPopupComponent
    ]
})
export class KartgeometriPopupModule { }
DependencyGraph.init();
